/**
 * Normalizes list endpoints that wrap the array differently:
 * - GET /acciones-sistema, GET /api/admin/activity-logs → `{ rows: AccionSistema[] }`
 * - GET /acciones-usuario → `{ acciones: AccionSistema[], total, limit, skip }`
 * Legacy deployments may still return a bare array.
 * @param {object|object[]|null|undefined} data
 * @returns {object[]}
 */
export function unwrapAccionesListPayload(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (data !== null && typeof data === "object") {
    const rec = /** @type {{ rows?: object[], acciones?: object[] }} */ (data);
    if (Array.isArray(rec.rows)) {
      return rec.rows;
    }
    if (Array.isArray(rec.acciones)) {
      return rec.acciones;
    }
  }
  return [];
}
